export const daysFromNow = (days: number) => {
  const date14DaysFromToday = new Date();
  date14DaysFromToday.setDate(date14DaysFromToday.getDate() + days);

  return date14DaysFromToday;
};

export const getDateWithoutTimezoneOffset = (date: Date) =>
  new Date(date.getTime() - 1000 * 60 * date.getTimezoneOffset());

export const addDaysToTimestamp = (date: Date, days: number) => {
  if (!date) return;
  let result = new Date(date.getTime());

  result.setDate(result.getDate() + days);
  return result;
};

export const getUnixTimestampInSeconds = () => parseInt((new Date().getTime() / 1000).toFixed(0));
